import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { fillColorAtSubstance } from "../../../../../utils/textUtils";
import { typeInfo } from "../../../../../constants/typeInfo";

import UnknownSwitch from "./UnknownSwitch";

const VocaCardFront = ({ currentPage, currentIndex, clickSwitch }) => {
  const { mode } = useSelector((state) => state.ui);
  // [사이즈 수술] 기존 "200% 폭 + scale(0.5)" 축소 기법은 redux mode에 의존해
  // 어긋나면 카드가 화면을 넘었다. 폭 100% 고정 + 실측 폰 판정 + 폰트만 축소.
  const isMobile = mode === "mobile" || Math.min(window.innerWidth, window.screen.width) <= 768;

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (currentIndex === 0) {
      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
      }, 5000);
    }
  }, [currentIndex]);

  return (
    <div
      style={{
        // 뒷면과 같은 칸에 포갠다(VocaCardPage 가 grid). 안쪽 스위치의 기준이기도
        // 하므로 relative 를 유지한다.
        gridArea: "1 / 1",
        position: "relative",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          border: "1px solid #EBEBEB",
          borderRadius: "10px",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            alignSelf: "stretch",
            backgroundColor: "#EBEBEB",
            padding: "16px",
            gap: "12px",
          }}
        >
          <div
            style={{
              fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "34px" : "60px",
              fontWeight: "bold",
              color: typeInfo["vocabulary"].color,
            }}
          >
            {currentPage.word}
          </div>
          <div
            style={{
              fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "18px" : "32px",
              color: "#2D2D2D",
              marginBottom: "8px",
            }}
          >
            {currentPage.pron}
          </div>
        </div>
        <div
          style={{
            padding: "16px",
            fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "17px" : "28px",
            lineHeight: "1.6",
          }}
        >
          {currentPage.kor.split("\n").map((line, index) => (
            <div key={index}>
              {fillColorAtSubstance(line, typeInfo["vocabulary"].color)}
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          // [토글 정돈] 폰에서 거대 스위치가 단어를 덮던 것 → 축소해 모서리에
          // iOS 는 backface-visibility 를 absolute 자식에게 물려주지 않아서,
          // 카드를 뒤집으면 이 스위치가 뒷면 왼쪽 위에 유령처럼 비쳤다.
          // 자식에게 직접 걸어야 뒷면에서 사라진다.
          backfaceVisibility: "hidden",
          WebkitBackfaceVisibility: "hidden",
          top: Math.min(window.innerWidth, window.screen.width) <= 768 ? "2px" : "10px",
          right: Math.min(window.innerWidth, window.screen.width) <= 768 ? "2px" : "16px",
          transform: Math.min(window.innerWidth, window.screen.width) <= 768 ? "scale(0.6)" : "none",
          transformOrigin: "top right",
          // 위의 backface 만으로는 iOS 에서 여전히 뒷면 왼쪽 위에 비쳤다(10/27 중앙고 단어 화면).
          // 스위치가 scale 로 따로 합성되면 부모의 뒤집힘을 따르지 않기 때문이라, 뒤집혀 있는 동안은 아예 감춘다.
          visibility: currentPage.isOpened ? "hidden" : "visible",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/* [단어장 v5] 모바일: 툴팁이 스크롤 따라다니는 버그 → 숨김. PC만 표시 */}
        {!(Math.min(window.innerWidth, window.screen.width) <= 768) && (
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-80px",
            textAlign: "left",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            color: "white",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "16px",
            whiteSpace: "nowrap",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
            opacity: showTooltip ? 1 : 0,
            transform: showTooltip ? "translateY(0)" : "translateY(-5px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          모르는 단어로 설정하면, 모아서 보여줘요!
        </div>
        )}
        <UnknownSwitch
          key={"switch_" + currentPage.word}
          initChecked={currentPage.isUnknown}
          onChange={clickSwitch}
        />
      </div>
    </div>
  );
};

export default VocaCardFront;
